import { useState } from "react"
import {
    Grid,
    Button,
    Divider
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { Alert } from "@material-ui/lab"
import AccountBalanceIcon from "@material-ui/icons/AccountBalance"
import ReceiptIcon from "@material-ui/icons/Receipt"
import TarjetaExtra from "../TarjetaExtra"
import TarjetaVuelos from "../TarjetaVuelos"
import TarjetaHotel from "../TarjetaHotel"
import VPagos from "./../VPagos/VistaComrpas"
import VCompras from "../Compras/VCompras"
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import EditAttributesIcon from '@material-ui/icons/EditAttributes';
import { catRoles } from "../../../constant/catRoles"
import { useSelector } from "react-redux"
import EditarDatos from "../EditarDatos"
import { usePermiso } from "../../../hooks/usePermiso"
import VGrupos from "../VGrupos"
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import { esFinalizado } from "../../../utils/esFinalizado"
import VNotificaciones from "../VNotificaciones"
import NotificationsIcon from '@material-ui/icons/Notifications'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import FlightIcon from '@material-ui/icons/Flight'
import VCheckIn from "../VCheckIn"
import VDocumentos from "../VDocumentos"
import VFacturas from "../VFacturas"
import VDevoluciones from "../VDevoluciones"
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'

const useStyles = makeStyles((theme) => ({
    tabButton: {
        height: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.8rem',
    },
}))

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index}>
            {value === index && <div>{children}</div>}
        </div>
    );
}

export default function TapCliente() {
    const classes = useStyles()
    const [value, setValue] = useState(0);
    const { profile } = useSelector(store => store.logeo)
    const { cliente } = useSelector(store => store.cliente)

    const [permitidoEditar] = usePermiso({ location: "FK_AdministrarClientes_Editar", initialValue: false })
    const [permitidoItems] = usePermiso({ location: "FK_AdministrarClientes_Items", initialValue: false })
    const [permitidoCheckIn] = usePermiso({ location: "FK_AdministrarClientes_CheckIn", initialValue: false })
    const [permitidoWallet] = usePermiso({ location: "FK_AdministrarClientes_Wallet", initialValue: false })

    const tabItems = [
        { label: "Movimientos", icon: <AccountBalanceIcon />, show: true },
        { label: "Detalle", icon: <ReceiptIcon />, show: true },
        { label: "Items", icon: <ShoppingCartIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoItems },
        { label: "Verificar", icon: <EditAttributesIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoEditar },
        { label: "Grupo", icon: <SupervisedUserCircleIcon />, show: true },
        { label: "Notificaciones", icon: <NotificationsIcon />, show: true },
        { label: "Check-In", icon: <FlightIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoCheckIn },
        { label: "Wallet", icon: <AttachFileIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || permitidoWallet },
        // { label: "Extras", icon: <ShoppingBasketIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER },
        { label: "Devoluciones", icon: <AssignmentReturnIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER },
        { label: "Facturas", icon: <InsertDriveFileIcon />, show: profile.Rol?.Id === catRoles.ADMINISTRADOR || profile.Rol?.Id === catRoles.DEVELOPER },
    ];

    return (
        <Grid item xs={12}>
            {
                esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso) && (
                    <Alert className="alerta" severity="info">
                        Esta referencia está en estatus de: {cliente.paquete?.CatEstatusProceso?.Descripcion}
                    </Alert>
                )
            }

            <Grid container spacing={2} style={{ marginBottom: 16 }}>
                {tabItems.map((item, index) => item.show && (
                    <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
                        <Button
                            fullWidth
                            variant={value === index ? "contained" : "outlined"}
                            color="secondary"
                            startIcon={item.icon}
                            onClick={() => setValue(index)}
                            className={classes.tabButton}
                        >
                            {item.label}
                        </Button>
                    </Grid>
                ))}
            </Grid>
            <Divider style={{ margin: "16px 0" }} />
            <TabPanel value={value} index={0}>
                <VPagos />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <TarjetaExtra />
                <TarjetaVuelos />
                <TarjetaHotel />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <VCompras />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <EditarDatos />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <VGrupos />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <VNotificaciones />
            </TabPanel>
            <TabPanel value={value} index={6}>
                <VCheckIn />
            </TabPanel>
            <TabPanel value={value} index={7}>
                <VDocumentos />
            </TabPanel>
            <TabPanel value={value} index={8}>
                {/* Extras contratados */}
            </TabPanel>
            <TabPanel value={value} index={9}>
                <VDevoluciones />
            </TabPanel>
            <TabPanel value={value} index={10}>
                <VFacturas />
            </TabPanel>
        </Grid>
    );
}
